import _ from 'lodash'
import cookPackedGroupsConfig from '../common/cook-packed-groups-config.js'
import getCurrentGroupJsonConfig from '../common/get-current-group-json-config.js'
import emptyHiddenI18nFields from '../common/empty-hidden-i18n-fields'

let currentLivePreviewJsonConfig = null
export default async function livePreviewJsonConfig({ state, dispatch }) {
  if (_.isEmpty(_.get(state, 'templateConfig.json_config'))) return

  const groupsConfig = cookPackedGroupsConfig({
    groupsConfig: state.groupsConfig,
    previewLanguageList: state.previewLanguageList,
    i18nResource: state.i18nResource,
    jsonConfig: state.templateConfig.json_config,
    gameConfigResource: state.gameConfigResource,
    category: state.templateConfig.category
  })
  const jsonConfig = getCurrentGroupJsonConfig({
    previewGroup: state.previewGroup,
    groupsConfig,
    gameConfigResource: state.gameConfigResource
  })

  const params = {}
  // languages.json
  if (jsonConfig.i18n) {
    params.i18n = {
      ...emptyHiddenI18nFields(jsonConfig.i18n, state.templateConfig.category)
    }
    params.previewLanguage = state.previewLanguage
  }
  // gameConfig.json
  if (
    [
      'autoEndTime',
      'playAgain',
      'gameDifficulty',
      'colorConfig',
      'gameConfig'
    ].some(item => !_.isUndefined(jsonConfig[item]))
  ) {
    params.gameConfig = _.omit(jsonConfig, ['i18n'])
  }

  const cookMwConfig = () => {
    const mwConfig = _.get(state, 'templateConfig.mw_config')
    const data = {}
    const hasGlobalClick = _.has(mwConfig, 'global_click')
    const hasAutoClick = _.has(mwConfig, 'auto_click')
    const hasYdClick = _.has(mwConfig, 'yd_click')

    // 设置跳转配置时，需要先做非空判断，否则会导致素材包的 MW_CONFIG 设置错误
    // 不等于1都代表是disable，后端输出的值可能是0/1/2
    if (hasGlobalClick) {
      data.disable_global_click = _.get(mwConfig, 'global_click') !== 1
    }
    if (hasAutoClick) {
      data.disable_auto_click = _.get(mwConfig, 'auto_click') !== 1
    }
    if (hasYdClick) {
      data.disable_yd_click = _.get(mwConfig, 'yd_click') !== 1
    }
    return data
  }

  // mwConfig
  if (_.get(state, 'templateConfig.mw_config')) {
    params.mwConfig = cookMwConfig()
  }

  // json config 没有变化，也可能会有需要 json 的实时预览的场景，如切换预览语言
  // 深拷贝去除引用类型印象
  currentLivePreviewJsonConfig = _.cloneDeep(params)
  await dispatch('livePreview', currentLivePreviewJsonConfig)
}
